/**
 * Registry Module Names
 */

// Core
export const CORE_MODULE = 'core';
export const DATEPICKER_MODULE = 'datepicker';
export const PS_QUOTE_FORM_MODULE = 'ps-quote-form';
export const LOCATOR_MODULE = 'locator';
export const COVER_SELECTOR_MODULE = "cover-selector";

// Dev
export const DEV_MODULE = 'dev';
export const DEV_THEME_SWITCHER = `${DEV_MODULE}-theme-switcher`;

// Health Fund
export const HF_APP_MODULE = 'hf-app';
export const HF_PRODUCT_SELECTOR_MODULE = 'hf-product-selector';
export const HF_PRODUCT_DETAIL_CARD_MODULE = 'hf-product-detail-card';

// Credit Union
export const CU_APP_MODULE = 'cu-app';
export const CU_PRODUCT_COMPARE_MODULE = 'cu-product-compare';

// NT Health Fund
export const NT_HF_APP_MODULE = 'nt-cu-app';



// WEBPACK FOOTER //
// ./project/client/src/core/registry/names.js